<template>
  <div class="container-fluid m-0 p-0">
    <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
      <div class="col-sm-12 h-100 my-auto p-0 m-0">
        <span class="mx-3 font-weight-bold lead">Clinic List</span>
        <span class="mx-3">
          <button class="btn btn-sm btn-outline-primary font-weight-bolder"
                  data-toggle="modal"
                  data-target="#add-clinic"
          >
            <span class="fas fa-plus"></span>
            Add Clinic
          </button>
        </span>
        <span class="float-right py-1 mx-2 pr-4">
          <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                  @click="goBack"
          >
            <span class="fas fa-backward"></span>
            Go Back
          </button>
        </span>
      </div>
    </div>

    <div class="row text-small pt-3">
      <div class="col col-md-12" style="min-height: 450px !important;">
        <div class="form-group form-inline">
          <label for="inputUser" class="pr-3 font-weight-bold">Search Clinic Here: </label>
          <input class="form-control form-control-sm mr-2 w-25" id="inputUser" style=""
                 type="text" placeholder="Input Any Here . . ."
                 v-model="searchValue"
                 @input="setPage(1)"
          >
          <button type="button" class="btn btn-primary btn-sm"
                  @click="searchValue = ''; setPage(1)"
          >CLEAR</button>

        </div>

        <div class=" table-responsive text-small" style="height: 475px;">
          <table  class="table table-hover table-bordered table-template-1 text-small sticky-header">
            <thead>
            <tr>
              <th>#</th>
              <th>CLINIC NAME</th>
              <th>EMAIL</th>
              <th>CONTACT PERSON</th>
              <th>TELEPHONE</th>
              <th>STATUS</th>
              <th class="col-actions">ACTION</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(clinic, index) in clinics" :key="clinic.id" :class="{ inactive: !clinic.active }">
              <td>{{ index + pagination.from }}</td>
              <td>{{ clinic.name }}</td>
              <td>{{ clinic.email }}</td>
              <td>{{ clinic.contact_person }}</td>
              <td>{{ clinic.telephone }}</td>
              <td>{{ clinic.active ? 'ACTIVE' : 'INACTIVE' }}</td>
              <td class="text-center col-actions">
                <button class="btn btn-sm btn-xs btn-warning font-weight-bolder mr-1 ml-auto"
                        data-toggle="modal"
                        data-target="#edit-clinic"
                        @click="viewClinic(clinic)"
                >
                  <span class="fas fa-edit"></span>
                  Edit
                </button>
                <button class="btn btn-sm btn-xs btn-outline-danger font-weight-bolder mr-1 ml-auto"
                        @click="confirmDeleteClinic(clinic.id)"
                >
                  <span class="fas fa-trash-alt"></span>
                  Delete
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>

      <nav aria-label="..." class="ml-3 pt-2">
        <ul class="pagination text-smallest">
          <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
            <button class="page-link" @click="setPage(1)">First</button>
          </li>

          <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
            <button class="page-link" @click="setPage(page)">{{ page }}</button>
          </li>

          <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
            <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
          </li>
        </ul>
      </nav>

    </div>

    <app-modal unique="edit-clinic" title="EDIT CLINIC DETAILS">

      <form @submit.prevent="confirmUpdateClinic">
        <div class="form-group form-row mb-1" :class="{'has-error': editClinicErrors.name }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="clinic-name" >
            Clinic Name:
          </label>
          <div class="col col-sm-9">
            <input type="text" id="clinic-name" required
                   class="form-control form-control-xs"
                   placeholder="CLINIC NAME NOT SPECIFIED"
                   v-model="editClinic.name"
            >
            <span class="help-block" v-if="editClinicErrors.name !== ''">
                <small><strong>{{ editClinicErrors.name }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': editClinicErrors.email }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="clinic-email" >
            Email:
          </label>

          <div class="col col-sm-9">
            <input type="email" id="clinic-email"
                   class="form-control form-control-xs"
                   placeholder="EMAIL NOT SPECIFIED"
                   v-model="editClinic.email"
            >
            <span class="help-block" v-if="editClinicErrors.email !== ''">
                <small><strong>{{ editClinicErrors.email }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': editClinicErrors.contact_person }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="clinic-contact-person" >
            Contact Person:
          </label>

          <div class="col col-sm-9">
            <input type="text" id="clinic-contact-person"
                   class="form-control form-control-xs"
                   placeholder="CONTACT PERSON NOT SPECIFIED"
                   v-model="editClinic.contact_person"
            >
            <span class="help-block" v-if="editClinicErrors.contact_person !== ''">
                <small><strong>{{ editClinicErrors.contact_person }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': editClinicErrors.telephone }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="clinic-telephone" >
            Telephone:
          </label>

          <div class="col col-sm-9">
            <input type="text" id="clinic-telephone"
                   class="form-control form-control-xs"
                   placeholder="TELEPHONE NOT SPECIFIED"
                   v-model="editClinic.telephone"
            >
            <span class="help-block" v-if="editClinicErrors.telephone !== ''">
                <small><strong>{{ editClinicErrors.telephone }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': editClinicErrors.address }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="clinic-address" >
            Address:
          </label>

          <div class="col col-sm-9">
            <textarea id="clinic-address" rows="5"
                      class="form-control form-control-xs"
                      placeholder="Address NOT SPECIFIED"
                      v-model="editClinic.address"
            ></textarea>
            <span class="help-block" v-if="editClinicErrors.address !== ''">
                <small><strong>{{ editClinicErrors.address }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': editClinicErrors.active }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="clinic-status" >
            Status:
          </label>

          <div class="col col-sm-9">
            <div class="form-check d-block">
              <select class="form-control form-control-xs" id="port-status" v-model="editClinic.active">
                <option value="">Select..</option>
                <option :value="1" >ACTIVE</option>
                <option :value="0">INACTIVE</option>
              </select>
            </div>
            <span class="help-block" v-if="editClinicErrors.active !== ''">
                <small><strong>{{ editClinicErrors.active }}</strong></small>
            </span>
          </div>
        </div>

        <hr style="border-color: #E0DED7"/>
        <button type="submit" class="btn btn-sm btn-warning font-weight-bolder float-right">
          <span class="fas fa-edit"></span>
          Update
        </button>

      </form>
    </app-modal>

    <app-modal unique="add-clinic" title="ADD CLINIC">

      <form @submit.prevent="confirmAddClinic">
        <div class="form-group form-row mb-1" :class="{'has-error': newClinicErrors.name }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="new-clinic-name" >
            Clinic Name:
          </label>
          <div class="col col-sm-9">
            <input type="text" id="new-clinic-name" required
                   class="form-control form-control-xs"
                   placeholder="ENTER CLINIC NAME HERE"
                   v-model="newClinic.name"
            >
            <span class="help-block" v-if="newClinicErrors.name !== ''">
                <small><strong>{{ newClinicErrors.name }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newClinicErrors.email }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="new-clinic-email" >
            Email:
          </label>

          <div class="col col-sm-9">
            <input type="email" id="new-clinic-email"
                   class="form-control form-control-xs"
                   placeholder="ENTER EMAIL OF THE CLINIC HERE"
                   v-model="newClinic.email"
            >
            <span class="help-block" v-if="newClinicErrors.email !== ''">
                <small><strong>{{ newClinicErrors.email }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newClinicErrors.contact_person }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="new-clinic-contact-person" >
            Contact Person:
          </label>

          <div class="col col-sm-9">
            <input type="text" id="new-clinic-contact-person"
                   class="form-control form-control-xs"
                   placeholder="ENTER CLINIC CONTACT PERSON HERE"
                   v-model="newClinic.contact_person"
            >
            <span class="help-block" v-if="newClinicErrors.contact_person !== ''">
                <small><strong>{{ newClinicErrors.contact_person }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newClinicErrors.telephone }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="new-clinic-telephone" >
            Telephone:
          </label>

          <div class="col col-sm-9">
            <input type="text" id="new-clinic-telephone"
                   class="form-control form-control-xs"
                   placeholder="ENTER CLINIC CONTACT NUMBER HERE"
                   v-model="newClinic.telephone"
            >
            <span class="help-block" v-if="newClinicErrors.telephone !== ''">
                <small><strong>{{ newClinicErrors.telephone }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newClinicErrors.address }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="new-clinic-address" >
            Address:
          </label>

          <div class="col col-sm-9">
            <textarea id="new-clinic-address" rows="5"
                      class="form-control form-control-xs"
                      placeholder="ENTER CLINIC ADDRESS HERE"
                      v-model="newClinic.address"
            ></textarea>
            <span class="help-block" v-if="newClinicErrors.address !== ''">
                <small><strong>{{ newClinicErrors.address }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newClinicErrors.active }">
          <label class="col col-sm-3 col-form-label font-weight-bolder text-right" for="new-clinic-status" >
            Status:
          </label>

          <div class="col col-sm-9">
            <div class="form-check d-block">
              <select class="form-control form-control-xs" id="port-status" v-model="newClinic.active">
                <option value="">Select..</option>
                <option :value="true" >ACTIVE</option>
                <option :value="false">INACTIVE</option>
              </select>
            </div>
            <span class="help-block" v-if="newClinicErrors.active !== ''">
                    <small><strong>{{ newClinicErrors.active }}</strong></small>
                </span>
          </div>
        </div>

        <hr style="border-color: #E0DED7"/>
        <button type="submit" class="btn btn-sm btn-outline-primary font-weight-bolder float-right">
          <span class="fas fa-edit"></span>
          Save
        </button>

      </form>
    </app-modal>

  </div>
</template>

<script>

import AppModal from "@/components/elements/AppModal";

import { mapGetters, mapActions } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { paginationMixin } from "@/mixins/paginationMixin";

export default {
  name: "ClinicIndex",

  mixins: [ vueAppMixin, paginationMixin ],

  components: { AppModal },

  data() {
    return {
      searchValue: '',

      editClinic: {},
      editClinicErrors: {},

      newClinic: {
        active: '',
      },
      newClinicErrors: {},

    }
  },

  methods: {
    ...mapActions([
        'getClinicList',
        'updateClinic',
        'addClinic',
        'deleteClinic'
    ]),

    initializeData() {
      this.getClinicList({});
    },

    searchClinic() {
      let page = this.pagination.currentPage;
      let params = {
        page: page,
        searchValue: this.searchValue,
      };
      this.getClinicList(params);
    },

    setPage(page) {
      this.pagination.currentPage = page;
      this.searchClinic();
    },

    viewClinic(clinic) {
      this.editClinic = Object.assign({}, clinic);
      this.editClinicErrors = {};
    },

    async confirmUpdateClinic() {
      if(await this.confirmUpdate()) {
        let params = {
          id: this.editClinic.id,
          name: this.editClinic.name,
          email: this.editClinic.email,
          contact_person: this.editClinic.contact_person,
          telephone: this.editClinic.telephone,
          address: this.editClinic.address,
          active: this.editClinic.active,
        };
        let updatedClinic = await this.updateClinic(params);
        if(updatedClinic) {
          if(updatedClinic.errors) {
            this.editClinicErrors = updatedClinic.errors;
          } else {
            this.successAlert('Clinic Successfully Updated', 'UPDATE');
            this.editClinic = {};
            this.editClinicErrors = {};
            document.getElementById('close-edit-clinic').click();
          }
        }
      }
    },

    async confirmAddClinic() {
      if(await this.confirmCreateAlert()) {
        let params = {
          name: this.newClinic.name,
          email: this.newClinic.email,
          contact_person: this.newClinic.contact_person,
          telephone: this.newClinic.telephone,
          address: this.newClinic.address,
          active: this.newClinic.active,
        };
        let newClinic = await this.addClinic(params);
        if(newClinic) {
          if(newClinic.errors) {
            this.newClinicErrors = newClinic.errors;
          } else {
            this.successAlert('Clinic Successfully Created', 'CREATE');
            this.newClinic = {};
            this.newClinicErrors = {};
            document.getElementById('close-add-clinic').click();
          }
        }

      }
    },

    async confirmDeleteClinic(clinicId) {
      if(await this.confirmDeleteAlert()) {
        let params = { id: clinicId };
        let deletedClinic = await this.deleteClinic(params);
        if(deletedClinic) {
          this.successAlert('Clinic Successfully Deleted', 'DELETE');
        }
      }
    }

  },

  computed: {
    ...mapGetters([
        'clinics'
    ])
  },

  created() {
    this.initializeData();
  }

}
</script>

<style scoped>

</style>
